import { render, staticRenderFns } from "./account_edit.vue?vue&type=template&id=463e14a4&scoped=true&"
import script from "./account_edit.vue?vue&type=script&lang=js&"
export * from "./account_edit.vue?vue&type=script&lang=js&"
import style0 from "./account_edit.vue?vue&type=style&index=0&id=463e14a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e14a4",
  null
  
)

export default component.exports